import { useEffect } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import classsNames from 'classnames';
import { c, t } from 'ttag';

import { required } from '@utils/validators';
import { Modal, ModalProps } from '@ui/Modal';
import { Button } from '@ui/Button';
import { Title } from '@ui/Title';
import { Input } from '@ui/Input';
import { FormError } from '@ui/FormError';

import s from './PhoneVerificationModal.sss';

export type FormData = {
  phoneNumber: string;
  verificationCode: string;
};

type Props = ModalProps & {
  isSmsConfiramtion: boolean,
  sendSmsLoading: boolean,
  timeToResendSms: number,
  title?: string,
  description?: string,
  onRequestedResendSms: (phoneNumber: string) => void,
};

export const PhoneVerificationModal: React.FC<Props> = ({
  className,
  isSmsConfiramtion,
  sendSmsLoading,
  timeToResendSms,
  title,
  description,
  onRequestClose,
  onRequestedResendSms,
  ...props
}) => {
  const form = useForm();
  const { submitting, values, submitError } = useFormState<FormData>();

  const phoneNumberText = (
    <b>
      {values.phoneNumber}
    </b>
  );

  useEffect(() => {
    return () => {
      form.reset();
    };
  }, [isSmsConfiramtion, form]);

  return (
    (
      <Modal
        {...props}
        onRequestClose={onRequestClose}
        className={classsNames(s.modal, className)}
      >
        <Title
          type="h3"
          bold={false}
        >
          {isSmsConfiramtion ? t`Підтвердити телефон` : title || t`Підтвердити телефон`}
        </Title>
        <p className={s.description}>
          {isSmsConfiramtion
            ? c('PhoneVerificationModal').jt`Ми відправили вам код у Viber/SMS на номер: ${phoneNumberText}`
            : description || t`Верифікуйте номер телефону`
          }
        </p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            await form.submit();
          }}
        >
          {isSmsConfiramtion ? (
            <Field<FormData['verificationCode']>
              name="verificationCode"
              validate={required}
            >
              {({ input, meta }) => (
                <Input
                  {...input}
                  type="number"
                  autoComplete="one-time-code"
                  required={true}
                  className={s.input}
                  label={t`Код з SMS`}
                  placeholder={t`Введіть код`}
                  error={(meta.touched && meta.error) || meta.submitError}
                />
              )}
            </Field>
          ) : (
            <Field<FormData['phoneNumber']>
              name="phoneNumber"
              validate={required}
            >
              {({ input, meta }) => (
                <Input
                  {...input}
                  className={s.input}
                  type="tel"
                  required={true}
                  label={t`Телефон`}
                  placeholder={t`+380`}
                  error={(meta.touched && meta.error) || meta.submitError}
                />
              )}
            </Field>
          )}

          {submitError && <FormError>{submitError}</FormError>}

          {isSmsConfiramtion && !!timeToResendSms && (
          <p className={s.timer}>
            {t`Ви зможете відправити SMS повторно через: ${timeToResendSms}`}
          </p>
          )}

          <Button
            type="submit"
            disabled={submitting}
            className={s.submit}
          >
            {t`Продовжити`}
          </Button>
        </form>
        {isSmsConfiramtion && (
        <Button
          theme="text"
          className={s.resend}
          disabled={!!timeToResendSms || sendSmsLoading}
          onClick={() => onRequestedResendSms(values.phoneNumber)}
        >
          {t`Надіслати код повторно`}
        </Button>
        )}
      </Modal>
    )
  );
};
